"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyVenueSchema = void 0;
const Yup = __importStar(require("yup"));
exports.AcademyVenueSchema = Yup.object().shape({
    venue: Yup.string().min(1, 'Too Short!').required('Venue name is required'),
    description: Yup.string().min(0, 'Too Short!').required('Venue description is required'),
    ageLimit: Yup.number().required('Age limit is required'),
    trainingDay: Yup.string().required('Training day is required'),
    fee: Yup.string()
        .matches(/^\d+(.\d{1,2})?$/, 'Must be valid with 2 decimal places e.g 10.00')
        .required('Monthly fee is required'),
    registrationFee: Yup.string()
        .matches(/^\d+(.\d{1,2})?$/, 'Must be valid with 2 decimal places e.g 10.00')
        .required('Registration fee is required'),
    location: Yup.string().required('Location is required'),
    locationState: Yup.string().required('State is required'),
    startDate: Yup.date().required('Start date is required'),
    isTrialAvailable: Yup.boolean(),
    trialFee: Yup.string()
        .nullable()
        .when('isTrialAvailable', {
        is: true,
        then: Yup.string()
            .matches(/^\d+(.\d{1,2})?$/, 'Must be valid with 2 decimal places e.g 10.00')
            .required('Registration fee is required'),
    }),
    maxTrial: Yup.number()
        .nullable()
        .when('isTrialAvailable', {
        is: true,
        then: Yup.number().min(1).required('Max trial is required'),
    }),
}).required();
//# sourceMappingURL=AdminFKA.js.map